import React, { useState, useEffect } from 'react';
import MainLayout from './layout/MainLayout';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Loader from './components/Loader';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Projects from './pages/Projects';
import Work from './pages/Work';
import './styles/index.css'

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate an initial loading delay
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />; // Show loader until app finishes loading
  }

  return (
    <Router>
      <MainLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path='/work' element={<Work/>}/>
        </Routes>
      </MainLayout>
    </Router>
  );
};

export default App;
